import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, ClockIcon, TagIcon, UsersIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const details = [{
  icon: CalendarDaysIcon,
  label: 'Sábado 15 de Agosto'
}, {
  icon: ClockIcon,
  label: '10:30 AM'
}, {
  icon: TagIcon,
  label: 'Gratuito'
}, {
  icon: UsersIcon,
  label: 'Solo 50 Cupos'
}];
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy" data-id="element-61" data-mp="129qwps0ic1r1">
      <div className="pointer-events-none absolute inset-0" style={{
      backgroundImage: 'url(https://i.imgur.com/tL2QzlX.jpg)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      filter: 'blur(6px)',
      transform: 'scale(1.1)'
    }} aria-hidden="true" data-id="element-62" data-mp="xae8b2tzmmmc" />
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'rgba(10, 20, 40, 0.30)'
    }} aria-hidden="true" data-id="element-63" data-mp="3d2labedjz91r" />
      <div className="absolute inset-x-0 top-0 z-10 h-px bg-gold" aria-hidden="true" data-id="element-64" data-mp="3j8ixz1o3okvr" />

      <div className="relative z-10 mx-auto max-w-4xl px-6 pb-20 pt-16 text-center sm:pb-28 sm:pt-24" data-id="element-65" data-mp="3j6ocnm8x2qr5">
        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="section-label" data-id="element-66" data-mp="3o59cvlo65afl">
          Seminario del Primer Comprador
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.08
      }} className="mt-6 font-serif text-5xl font-light leading-[1.08] text-white sm:text-6xl lg:text-7xl" data-id="element-67" data-mp="30gzuktq5z4t7">
          Deja de Rentar y Haz Tu Sueño Realidad
        </motion.h1>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.14
      }} className="mx-auto mt-8 h-px w-20 bg-gold" aria-hidden="true" data-id="element-68" data-mp="2vgllr9gqnqu4" />

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.16
      }} className="mx-auto mt-8 max-w-2xl font-sans text-base font-light leading-relaxed text-white/85 sm:text-lg" data-id="element-69" data-mp="s2b921mmap6q">
          Comprar una casa es más fácil de lo que te imaginas. Cenia te quiere enseñar cómo
          lograrlo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.24
      }} className="mt-9 flex justify-center" data-id="element-70" data-mp="1azumdhg3ytyy">
          <ul className="flex flex-wrap items-center justify-center gap-x-3 gap-y-3 rounded-full bg-white/[0.06] px-6 py-4 sm:gap-x-5" data-id="element-71" data-mp="11150zep06rdy">
            {details.map(({
            icon: Icon,
            label
          }, index) => <li key={label} className="flex items-center" data-id="element-72" data-mp="3luiawvasv7nh" data-mpi={index}>
                <span className="flex items-center gap-2 font-sans text-[11px] font-medium uppercase tracking-[0.18em] text-white sm:text-xs" data-id="element-73" data-mp="3hqu0m4us9xyj">
                  <Icon className="h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-74" data-mp="1xb5q6f7x0tgn" />
                  {label}
                </span>
                {index < details.length - 1 && <span className="ml-3 hidden h-4 w-px bg-gold/50 sm:block" aria-hidden="true" data-id="element-75" data-mp="2b1hjuik5f09w" />}
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.32
      }} className="mt-10" data-id="element-76" data-mp="2ky44p7ch5rbx">
          <CtaButton size="lg" data-id="element-77" data-mp="2tztu67msqg72">Reserva tu lugar gratis</CtaButton>
          <p className="mt-6 font-sans text-[11px] uppercase tracking-[0.24em] text-white/60" data-id="element-78" data-mp="2tx7n093ti2pd">
            Cenia Badillo · Realtor · Coldwell Banker Realty
          </p>
        </motion.div>
      </div>
    </header>;
}